export enum PagePathV2 {
  Home = '/home',

  CourseCenter = '/course/list',
  CourseDetail = '/course',

  Essay = '/essay',
  Article = '/article',
  ArticleAgreement = '/article/agreement',

  Login = '/account/login',
  Search = '/search',
  ModuleLandingPage = '/module',
}
